import dateFormat from "dateformat";
import isDefined from "../../../../Core/isDefined";
import { formatDateTime } from "../DateFormats";
import * as DTP from "./DateTimePickerStyles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TimeListView = _ref => {
  let {
    items,
    dateFormatString,
    onTimeSelected
  } = _ref;
  if (!isDefined(items)) return null;
  return /*#__PURE__*/_jsxs(DTP.Grid, {
    children: [/*#__PURE__*/_jsx(DTP.GridHeading, {
      children: "Select a time"
    }), /*#__PURE__*/_jsx(DTP.GridBody, {
      children: items.map(item => /*#__PURE__*/_jsx(DTP.DateButton, {
        onClick: () => onTimeSelected(item),
        children: isDefined(dateFormatString) ? dateFormat(item, dateFormatString) : formatDateTime(item)
      }, formatDateTime(item)))
    })]
  });
};